if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      // Find the real form or bail quietly
      this.form = this.querySelector('form') || this.closest('form');
      if (!this.form) {
        console.warn('product-form: no <form> inside', this);
        return;
      }

      // Enable variant id input if present
      const idInput = this.form.querySelector('[name="id"]') || this.querySelector('[name="id"]');
      if (idInput) idInput.disabled = false;

      // Submit handling
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

      // Cart targets
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

      // Submit button
      this.submitButton = this.querySelector('[type="submit"]') || this.form.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer') && this.submitButton) {
        this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }

      this.hideErrors = this.dataset.hideErrors === 'true';

      // Optional: product container and media gallery
      this.productContainer = this.closest('.product') || document.querySelector('.product');
      this.mediaGallery = this.productContainer ? this.productContainer.querySelector('media-gallery') : null;

      // Variant change listener
      this.form.addEventListener('change', this.onVariantChange.bind(this));
    }

    // Keep gallery in sync with selected variant - all guarded
    onVariantChange() {
      if (!this.form) return;
      const idInput = this.form.querySelector('[name="id"]');
      if (!idInput) return;

      const variantsNode = this.querySelector('[data-variants]');
      if (!variantsNode) return;

      let variants;
      try {
        variants = JSON.parse(variantsNode.textContent);
      } catch (e) {
        console.warn('product-form: bad variants JSON', e);
        return;
      }

      const selectedVariant = variants.find(v => String(v.id) === String(idInput.value));
      if (selectedVariant && selectedVariant.featured_media && this.mediaGallery && typeof this.mediaGallery.setActiveMedia === 'function') {
        if (!this.mediaGallery.dataset.initialized) {
          this.mediaGallery.dataset.initialized = 'true';
        } else {
          this.mediaGallery.setActiveMedia(selectedVariant.featured_media.id);
        }
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (!this.form || !this.submitButton) return;
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      const spinner = this.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        if (this.cart.setActiveElement) this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            const span = this.submitButton.querySelector('span');
            if (span) span.classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
          this.error = false;

          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response); });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          const spinner = this.querySelector('.loading-overlay__spinner');
          if (spinner) spinner.classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage && this.errorMessage) this.errorMessage.textContent = errorMessage;
    }
  });
}

// Sticky cart modal - add guards so it does nothing on pages without the elements
class stickyCartModal extends HTMLElement {
  constructor() {
    super();
    window.addEventListener('scroll', this.update.bind(this));
    this.update();
    const footer = document.querySelector('.footer__content');
    if (footer) footer.classList.add('sticky-cart-modal_bottom_padding');
    const btn = this.querySelector('.sticky-cart-button');
    if (btn) {
      btn.addEventListener('click', this.onClickHandler.bind(this));
      btn.addEventListener('keydown', this.onClickKeydownHandler.bind(this));
    }
  }
  update(){
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    if (!button) return;
    const addButton = button.querySelector('[name="add"]');
    if (!addButton) return;
    const rangeToShowModal = this.getTop(addButton) + addButton.clientHeight;
    if (window.scrollY >= rangeToShowModal && !this.classList.contains('show-modal')) {
      this.classList.add('show-modal');
      document.querySelector('body').classList.add('modal__sticky-cart');
    }
    if (window.scrollY < rangeToShowModal && this.classList.contains('show-modal')) {
      this.classList.remove('show-modal');
      document.querySelector('body').classList.remove('modal__sticky-cart');
    }
  }
  onClickKeydownHandler(event){
    if (!event || event.code.toUpperCase() !== 'ENTER') return;
    this.onClickHandler();
  }
  onClickHandler(){
    const item = document.getElementById('variants-container');
    const btn_item = document.getElementById('product-container');
    const _y = item ? this.getTop(item) : (btn_item ? this.getTop(btn_item) : 0);
    this.scrollTo(_y, 700);
  }
  getTop(el) {
    if (!el) return 0;
    return el.offsetTop + (el.offsetParent ? this.getTop(el.offsetParent) : 0);
  }
  scrollTo(to){
    const element = document.scrollingElement || document.documentElement;
    element.scrollTop = to;
  }
}
customElements.define('sticky-cart-modal', stickyCartModal);
